import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-layout-html-table',
  templateUrl: './dynamic-layout-html-table.component.html',
  styleUrls: ['./dynamic-layout-html-table.component.css']
})
export class DynamicLayoutHtmlTableComponent implements OnInit {

    _tile: any = null;
    _values: any;

  constructor() { }

  ngOnInit() {
    }

    @Input()
    set tile(tile: any) {
        
        this._tile = tile;
    }
    get tile(): any {
        return this._tile;
    }

    @Input()
    set values(values: any) {
        
        this._values = values;
    }
    get values(): any {
        return this._values;
    }
}
